package nl.volleyplanner.nevoboservice.extensions

/**
 * Beware not to change this function without testing
 * Slugs are generated from names and stored in the DB for lookups.
 * An update to a slug could cause a new record to be created instead of updating an existing record
 * (which we know isn't a great practice... but it is where we are Today.)
 */
fun String.toSlug() : String {
    return this
        .lowercase()
        .replaceAccents()                               // Remove accents in a multiplatform-friendly way
        .replace("[^a-z0-9\\s-]".toRegex(), "")         // Remove non-alphanumeric characters except spaces and hyphens
        .replace("\\s+".toRegex(), "-")                 // Replace spaces with hyphens
        .replace("-+".toRegex(), "-")                   // Replace multiple hyphens with a single one
        .trim('-')
}

fun String.toRequestFilePath() : String {
    return this
        .lowercase()
        .replaceAccents()
        .replace("=", "-")
        .replace("&", "_")
        .replace("[^=&a-z0-9\\s-]".toRegex(), "")         // Remove non-alphanumeric characters except spaces and hyphens
        .trim('-')
}

internal val accents = mapOf(
    'à' to 'a', 'á' to 'a', 'â' to 'a', 'ã' to 'a', 'ä' to 'a', 'å' to 'a', 'ā' to 'a',
    'è' to 'e', 'é' to 'e', 'ê' to 'e', 'ë' to 'e', 'ē' to 'e', 'ė' to 'e', 'ę' to 'e',
    'ì' to 'i', 'í' to 'i', 'î' to 'i', 'ï' to 'i', 'ī' to 'i', 'į' to 'i',
    'ò' to 'o', 'ó' to 'o', 'ô' to 'o', 'õ' to 'o', 'ö' to 'o', 'ø' to 'o', 'ō' to 'o',
    'ù' to 'u', 'ú' to 'u', 'û' to 'u', 'ü' to 'u', 'ū' to 'u',
    'ç' to 'c', 'ć' to 'c', 'č' to 'c',
    'ñ' to 'n', 'ń' to 'n',
    'ß' to 's',
    'ÿ' to 'y', 'ý' to 'y'
)

// Helper function to replace common accents without using Normalizer
fun String.replaceAccents(): String {
    return this.map { accents[it] ?: it }.joinToString("")
}